import { create } from 'zustand';
import { immer } from 'zustand/middleware/immer';
import { nanoid } from 'nanoid';
import type { SurfaceId } from './surfaces';

export type Severity = 'passive' | 'info' | 'important' | 'urgent';

export interface AppNotification {
  id: string;
  surfaceId: SurfaceId;
  severity: Severity;
  text: string;
  createdAt: number;
}

interface NotificationsStore {
  items: AppNotification[];
  push: (n: Omit<AppNotification, 'id' | 'createdAt'>) => void;
  dismiss: (id: string) => void;
  clearAll: () => void;
}

export const useNotifications = create<NotificationsStore>()(
  immer((set) => ({
    items: [],
    push: (n) => set((s) => {
      s.items.unshift({ ...n, id: nanoid(), createdAt: Date.now() });
      if (s.items.length > 5) s.items.length = 5;
    }),
    dismiss: (id) => set((s) => {
      s.items = s.items.filter((n) => n.id !== id);
    }),
    clearAll: () => set((s) => { s.items = []; }),
  })),
);
